/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignInMethodEntity
 */
export interface SignInMethodEntity {
    /**
     * 認証プロバイダー種別
     * "emailpassword", "thirdparty", "passwordless", "webauthn" のいずれか。
     * @type {string}
     * @memberof SignInMethodEntity
     */
    identityProviderType: SignInMethodEntityIdentityProviderTypeEnum;
    /**
     * テナントId
     * @type {Array<string>}
     * @memberof SignInMethodEntity
     */
    tenantIds: Array<string>;
    /**
     * サードパーティ認証プロバイダー ID（identityProviderType が thirdparty のとき）
     * @type {string}
     * @memberof SignInMethodEntity
     */
    thirdPartyId?: string;
    /**
     * メールアドレス確認
     * @type {boolean}
     * @memberof SignInMethodEntity
     */
    emailVerified: boolean;
    /**
     * 最終サインイン日時
     * @type {number}
     * @memberof SignInMethodEntity
     */
    lastSignInTime: number;
    /**
     * 
     * @type {string}
     * @memberof SignInMethodEntity
     */
    recipeUserId: string;
}


/**
 * @export
 */
export const SignInMethodEntityIdentityProviderTypeEnum = {
    Emailpassword: 'emailpassword',
    Thirdparty: 'thirdparty',
    Passwordless: 'passwordless',
    Webauthn: 'webauthn'
} as const;
export type SignInMethodEntityIdentityProviderTypeEnum = typeof SignInMethodEntityIdentityProviderTypeEnum[keyof typeof SignInMethodEntityIdentityProviderTypeEnum];


/**
 * Check if a given object implements the SignInMethodEntity interface.
 */
export function instanceOfSignInMethodEntity(value: object): value is SignInMethodEntity {
    if (!('identityProviderType' in value) || value['identityProviderType'] === undefined) return false;
    if (!('tenantIds' in value) || value['tenantIds'] === undefined) return false;
    if (!('emailVerified' in value) || value['emailVerified'] === undefined) return false;
    if (!('lastSignInTime' in value) || value['lastSignInTime'] === undefined) return false;
    if (!('recipeUserId' in value) || value['recipeUserId'] === undefined) return false;
    return true;
}

export function SignInMethodEntityFromJSON(json: any): SignInMethodEntity {
    return SignInMethodEntityFromJSONTyped(json, false);
}

export function SignInMethodEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInMethodEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'identityProviderType': json['identityProviderType'],
        'tenantIds': json['tenantIds'],
        'thirdPartyId': json['thirdPartyId'] == null ? undefined : json['thirdPartyId'],
        'emailVerified': json['emailVerified'],
        'lastSignInTime': json['lastSignInTime'],
        'recipeUserId': json['recipeUserId'],
    };
}

export function SignInMethodEntityToJSON(json: any): SignInMethodEntity {
    return SignInMethodEntityToJSONTyped(json, false);
}

export function SignInMethodEntityToJSONTyped(value?: SignInMethodEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identityProviderType': value['identityProviderType'],
        'tenantIds': value['tenantIds'],
        'thirdPartyId': value['thirdPartyId'],
        'emailVerified': value['emailVerified'],
        'lastSignInTime': value['lastSignInTime'],
        'recipeUserId': value['recipeUserId'],
    };
}

